import { reduce } from 'lodash';
import { isHexColor } from '@wix/communities-blog-rce';
import tinyColor from 'tinycolor2';
import { LINK_AND_HASHTAG_COLOR, POST_TEXT_COLOR, POST_TITLE_COLOR } from '../../app/constants/wix-params';
import { getPresetColor, getSiteColor } from '../../app/services/colors';

export const getTextColorSchema = (appSettings = {}) => {
  const colors = [
    getSiteColor(appSettings, { wixParam: POST_TEXT_COLOR, presetFallback: 'color-5', colorFallback: '#00000' }),
    getSiteColor(appSettings, { wixParam: POST_TITLE_COLOR, presetFallback: 'color-5', colorFallback: '#00000' }),
    getSiteColor(appSettings, {
      wixParam: LINK_AND_HASHTAG_COLOR,
      presetFallback: 'color-8',
      colorFallback: '#00000',
    }),
    getPresetColor(appSettings, 'color-13'),
    getPresetColor(appSettings, 'color-18'),
    getPresetColor(appSettings, 'color-23'),
  ];

  return reduce(
    colors,
    (schema, color, index) => {
      schema[`textColor${index}`] = { color: toHexColor(color), index };
      return schema;
    },
    {},
  );
};

const toHexColor = color => tinyColor(color).toHexString();

export const styleSelectionPredicate = colorScheme => inlineStyle =>
  (colorScheme[inlineStyle] && isHexColor(colorScheme[inlineStyle].color)) || isHexColor(inlineStyle);

export const viewerCustomStyleFn = colorScheme => inlineStyle => {
  if (colorScheme[inlineStyle] && isHexColor(colorScheme[inlineStyle].color)) {
    return { color: colorScheme[inlineStyle].color };
  }

  if (isHexColor(inlineStyle)) {
    return { color: inlineStyle };
  }

  return {};
};

export const customStyleFn = viewerCustomStyleFn => inlineStyles =>
  reduce(
    inlineStyles.toArray(),
    (styles, inlineStyle) => ({
      ...styles,
      ...viewerCustomStyleFn(inlineStyle),
    }),
    {},
  );
